// extracted by mini-css-extract-plugin
export default {"documentsContainer":"Documents_documentsContainer__L8K8N","documentItem":"Documents_documentItem__xefUE","documentActions":"Documents_documentActions__-xsNi"};